<div class="container-fluid">
  <div class="header-container">
    <div class="row   justify-content-start mb-2">
      <div class="col-12">
      <span class="iso-header ml-2">
{{ "bikeshop.shop_setup.card_headers.manage_subscription" | translate }}
</span>
      </div>
    </div>
    <div *ngIf="hasActiveSubscription" class="button-container">
      <button pButton type="button" class="p-button-raised p-mini"
              (click)="openStripePortal()" [disabled]="!stripePortalURL"
              label="{{ 'bikeshop.manage_subscription.view_invoices' | translate }}"></button>
      <button pButton type="button" class="p-button-raised p-mini"
              (click)="setEditSubscription()"
              label="{{ (!editSubscription ? 'bikeshop.manage_subscription.update_subscription' : 'bikeshop.manage_subscription.cancel_update') | translate }}"></button>
    </div>
  </div>

  <div class="content">
    <div class="product-title">{{'bikeshop.manage_subscription.workshop' | translate}}</div>
    <div class="features-container">
      <div class="feature" *ngFor="let feature of workshopFeatures"><span
        class="fa fa-check-square"></span>{{feature}}
      </div>
    </div>

    <div *ngIf="loadingPlans || busyCancelling" class="margin-top-16">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="plan-container">
      <div *ngFor="let plan of workshopPlans" class="plan" (click)="selectWorkshopPlan(plan)"
           pTooltip="{{editSubscription && selectedWorkshopPlan == plan.portalIdentifier ? ('bikeshop.manage_subscription.remove_product_tooltip' | translate) : ''}}"
           [ngClass]="{'selected': selectedWorkshopPlan == plan.portalIdentifier, 'disabled': loadingStripePricing || (hasActiveSubscription && !editSubscription)}">
        <div class="header">
          <div class="title">{{plan.title}}</div>
          <div class="price">
            <div *ngIf="plan.portalIdentifier !== 'WORKSHOP_TRIAL' && loadingStripePricing">
              <p-progressSpinner [style]="{ width: '36px', height: '36px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
            <div *ngIf="plan.portalIdentifier == 'WORKSHOP_TRIAL'">{{'bikeshop.manage_subscription.trial' | translate}}
            </div>
            <div *ngIf="plan.pricing"
                 [ngClass]="{'discounted': selectedWorkshopPlan == plan.portalIdentifier && isWorkshopDiscounted()}">
              {{getCurrencySymbol(plan.pricing.currency)}}{{(plan.pricing.amount / 100).toFixed(0)}}
              / {{'general.month' |
              translate}}
            </div>
          </div>
          <div class="price"
               *ngIf="plan.pricing && selectedWorkshopPlan == plan.portalIdentifier && isWorkshopDiscounted()">
            <div>
              {{getCurrencySymbol(plan.pricing.currency)}}{{getDiscountedAmount(plan).toFixed(2)}}
              / {{'general.month' |
              translate}}
            </div>
          </div>

        </div>
        <div class="plan-divider"></div>
        <div class="plan-content">
          <div class="extra-info"><span class="fa fa-check-square"></span>{{
            'bikeshop.manage_subscription.all_workshop_features' | translate }}</div>
          <div class="extra-info" *ngIf="plan.technicians"><span
            class="fa fa-check-square"></span>{{plan.technicians}}
            {{(plan.technicians === "1" ?
              'bikeshop.quicklaunch.technician' : 'bikeshop.quicklaunch.technicians') | translate}}</div>
          <div class="extra-info" *ngIf="plan.SMS"><span class="fa fa-check-square"></span>{{plan.SMS}} {{
            'bikeshop.manage_subscription.sms_credits_monthly' |
              translate}}</div>
        </div>
        <!-- <div class="plan-divider"></div>
        <div>
          <button pButton type="button" class="p-button-raised full-width"
            [disabled]="loadingStripePricing || selectedWorkshopPlan == plan.portalIdentifier"
            (click)="selectedWorkshopPlan = plan.portalIdentifier"
            label="{{ 'bikeshop.manage_subscription.select_plan' | translate }}"></button>
        </div> -->

      </div>
    </div>

  </div>


  <div class="workshop-rental-discount"
       *ngIf="!loadingPlans && !busyCancelling && (!hasActiveSubscription || (hasActiveSubscription && editSubscription))">
    <div>{{'bikeshop.manage_subscription.workshop_and_rental_discount_header' | translate : {
      discountAmount:
      packageDiscountAmount
    } }}</div>
    <div>{{'bikeshop.manage_subscription.workshop_and_rental_discount' | translate : {
      discountAmount:
      packageDiscountAmount
    } }}</div>
  </div>


  <div class="content">
    <div class="product-title">{{'bikeshop.manage_subscription.rentals' | translate}}</div>
    <div class="features-container">
      <div class="feature" *ngFor="let feature of rentalFeatures"><span
        class="fa fa-check-square"></span>{{feature}}
      </div>
    </div>

    <div *ngIf="loadingPlans || busyCancelling" class="margin-top-16">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="plan-container">
      <div *ngFor="let plan of rentalPlans" class="plan" (click)="selectRentalPlan(plan)"
           pTooltip="{{editSubscription && selectedRentalPlan == plan.portalIdentifier ? ('bikeshop.manage_subscription.remove_product_tooltip' | translate) : ''}}"
           [ngClass]="{'selected': selectedRentalPlan == plan.portalIdentifier, 'disabled': loadingStripePricing || (hasActiveSubscription && !editSubscription)}">
        <div class="header">
          <div class="title">{{plan.title}}</div>
          <div class="price">
            <div *ngIf="plan.portalIdentifier !== 'RENTAL_TRIAL' && loadingStripePricing">
              <p-progressSpinner [style]="{ width: '36px', height: '36px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
            <div *ngIf="plan.portalIdentifier == 'RENTAL_TRIAL'">{{'bikeshop.manage_subscription.trial' |
              translate}}
            </div>
            <div *ngIf="plan.pricing"
                 [ngClass]="{'discounted': selectedRentalPlan == plan.portalIdentifier && isRentalDiscounted()}">
              {{getCurrencySymbol(plan.pricing.currency)}}{{(plan.pricing.amount / 100).toFixed(0)}} /
              {{'general.month' |
              translate}}
            </div>
          </div>
          <div class="price"
               *ngIf="plan.pricing && selectedRentalPlan == plan.portalIdentifier && isRentalDiscounted()">
            <div>
              {{getCurrencySymbol(plan.pricing.currency)}}{{getDiscountedAmount(plan).toFixed(2)}}
              / {{'general.month' |
              translate}}
            </div>
          </div>
        </div>
        <div class="plan-divider"></div>
        <div class="plan-content">
          <div class="extra-info"><span class="fa fa-check-square"></span>{{
            'bikeshop.manage_subscription.all_rental_features' | translate }}</div>
          <div class="extra-info" *ngIf="plan.rentalItems"><span
            class="fa fa-check-square"></span>{{plan.rentalItems}}
            {{'bikeshop.manage_subscription.rental_items' | translate}}</div>
        </div>
        <!-- <div class="plan-divider"></div>
        <div>
          <button pButton type="button" class="p-button-raised full-width"
            [disabled]="loadingStripePricing || selectedRentalPlan == plan.portalIdentifier"
            (click)="selectedRentalPlan = plan.portalIdentifier"
            label="{{ 'bikeshop.manage_subscription.select_plan' | translate }}"></button>
        </div> -->

      </div>
    </div>
  </div>



  <div class="content">
    <div class="product-title">{{'bikeshop.manage_subscription.addons' | translate}}</div>
    <div class="features-container">
      <!-- <div class="feature" *ngFor="let feature of addOnFeatures"><span
        class="fa fa-check-square"></span>{{feature}}
      </div> -->
    </div>
  
    <div *ngIf="loadingPlans || busyCancelling" class="margin-top-16">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="plan-container">
      <div *ngFor="let plan of addonPlans" class="plan add-on disabled"
           pTooltip="{{editSubscription && selectedRentalPlan == plan.portalIdentifier ? ('bikeshop.manage_subscription.remove_product_tooltip' | translate) : ''}}"          
           (click)="selectAddOnPlan(plan)"
           [ngClass]="{'selected': addOnSelected(plan), 'disabled': loadingStripePricing || (hasActiveSubscription && !editSubscription)}">
           
        <div class="header">
          <div class="title">{{plan.title}}</div>
          <div class="price">
            <div *ngIf="loadingStripePricing">
              <p-progressSpinner [style]="{ width: '36px', height: '36px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
            <div *ngIf="plan.pricing"
                 [ngClass]="{'discounted': selectedRentalPlan == plan.portalIdentifier && isRentalDiscounted()}">
              {{getCurrencySymbol(plan.pricing.currency)}}{{(plan.pricing.amount / 100).toFixed(0)}} /
              {{'general.month' |
              translate}}
            </div>
          </div>
          <div class="price"
               *ngIf="plan.pricing && selectedRentalPlan == plan.portalIdentifier && isRentalDiscounted()">
            <div>
              {{getCurrencySymbol(plan.pricing.currency)}}{{getDiscountedAmount(plan).toFixed(2)}}
              / {{'general.month' |
              translate}}
            </div>
          </div>
        </div>
        <div class="plan-divider"></div>
        <div class="plan-content" *ngIf="plan.portalIdentifier === 'WHATSAPP'">
          <div *ngFor="let feature of whatsappFeatures" class="extra-info"><span class="fa fa-check-square"></span>{{ feature }}</div>
        </div>
  
      </div>
    </div>
  </div>
  



</div>



<div class="cancel-container" *ngIf="hasActiveSubscription && editSubscription && stripePortalURL">
  <button pButton type="button" class="p-button-raised alternate"
          (click)="displayCancellationReason = true;"
          label="{{ 'bikeshop.manage_subscription.cancel_subscription' | translate }}"></button>
</div>

<div style="margin-bottom:120px"></div>

<div class="subscription-action-container"
     [ngClass]="{'active': isProductSelected() && hasSubscriptionChanged() && ((hasActiveSubscription && editSubscription && hasSubscriptionChanged()) || !hasActiveSubscription)}">

  <div
    *ngIf="selectedWorkshopPlan && selectedRentalPlan && (selectedWorkshopPlan !== 'WORKSHOP_TRIAL' && selectedRentalPlan !== 'RENTAL_TRIAL')">
    <div class="plan-summary">{{ getSummary() }}</div>
  </div>
  <div *ngIf="selectedWorkshopPlan && !selectedRentalPlan && (selectedWorkshopPlan !== 'WORKSHOP_TRIAL')">
    <div class="plan-summary">{{ getWorkshopOnlySummary() }}</div>
  </div>
  <div *ngIf="selectedRentalPlan && !selectedWorkshopPlan && (selectedRentalPlan !== 'RENTAL_TRIAL')">
    <div class="plan-summary">{{ getRentalOnlySummary() }}</div>
  </div>

  <div *ngIf="busyUpdating" style="margin-top: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <div *ngIf="!hasActiveSubscription && !busyUpdating && !isTrialOnly()">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.manage_subscription.create_subscription' | translate
    }}" (click)="createSubscription()" [disabled]="busyUpdating"></button>
  </div>
  <div *ngIf="!hasActiveSubscription && !busyUpdating && isTrialOnly()">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.manage_subscription.create_trial' | translate
    }}" (click)="createTrial()" [disabled]="busyUpdating"></button>
  </div>
  <div *ngIf="hasActiveSubscription && editSubscription && !busyUpdating">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.manage_subscription.update_subscription' | translate
    }}" (click)="updateSubscriptionConfirm()" [disabled]="busyUpdating"></button>
  </div>
</div>


<p-toast position="bottom-center" styleClass="hubtiger-toast"></p-toast>

<p-sidebar #NavSideBar [(visible)]="showSubscriptionPayment" position="right" [autoZIndex]="false"
           [baseZIndex]="0"
           [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto','z-index': '1001'}"
           (onHide)="getSubscriptionProducts(); NavSideBar.destroyModal()">
  <div *ngIf="showSubscriptionPayment">
    <app-subscription-payment [paymentData]="paymentData" [countryData]="countryData" [currencies]="currencies"
                              (close)="closeRentalProduct()"></app-subscription-payment>
  </div>
</p-sidebar>

<p-dialog [(visible)]="displayCancellationReason" [modal]="true">
  <p-header>
    <div class="cancel-header">
      {{'bikeshop.manage_subscription.cancel_subscription' | translate }}
    </div>
  </p-header>
  <div>
    <div>
      <div class="row margin-top-8">
        <div class="col-md-12 label">
          {{ "bikeshop.manage_subscription.cancel_subscription_reason" | translate }}:
        </div>
        <div class="col-md-12 value">
          <input pInputText type="text" [(ngModel)]="cancellationReason"/>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton label="{{ 'general.no' | translate }}"
            (click)="displayCancellationReason = false"></button>
    <button type="button" pButton label="{{ 'bikeshop.manage_subscription.cancel_subscription' | translate }}"
            [disabled]="cancellationReason === null || cancellationReason === undefined || cancellationReason === ''"
            (click)="cancelStripeSubscription()"></button>
  </p-footer>
</p-dialog>

<p-confirmDialog key="update_subscription_confirmation"></p-confirmDialog>
